"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[798,749],{

/***/ 3749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BTCValueCard": function() { return /* binding */ BTCValueCard; },
/* harmony export */   "BlogCard": function() { return /* binding */ BlogCard; },
/* harmony export */   "CalculatorCard": function() { return /* binding */ CalculatorCard; },
/* harmony export */   "GraphCard": function() { return /* binding */ GraphCard; },
/* harmony export */   "ImageBGCard": function() { return /* binding */ ImageBGCard; },
/* harmony export */   "LatestBlogCard": function() { return /* binding */ LatestBlogCard; },
/* harmony export */   "OutputCard": function() { return /* binding */ OutputCard; },
/* harmony export */   "WarningCard": function() { return /* binding */ WarningCard; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71383);
/* harmony import */ var atomic_layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19010);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42997);



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;


 // TODO: green/red text

var BTCValueCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  box-shadow: ", ";\n  width: 100%;\n  min-width: 25rem;\n  align-items: center;\n  justify-content: space-between;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 0 2rem;\n  background: ", ";\n  @media screen and (max-width: ", ") {\n    flex: 1;\n  }\n  @media screen and (max-width: ", ") {\n    height: 100px;\n  }\n  min-height: 100px;\n  height: 100%;\n  box-sizing: border-box;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.shadow;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.glassEffect.blur;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.glassEffect.blur;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.glassBackground;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.lg.maxWidth;
});
var CalculatorCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  box-shadow: ", ";\n  flex-direction: column;\n  align-items: center;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 1rem;\n  background: ", ";\n  box-sizing: border-box;\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.shadow;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.glassEffect.blur;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.glassEffect.blur;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.glassBackground;
});
var GraphCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  overflow: hidden;\n  box-shadow: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 1rem;\n  background: ", ";\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  .recharts-wrapper > svg.recharts-surface {\n    margin-top: 15px;\n  }\n  @media screen and (max-width: ", ") {\n    .recharts-wrapper > svg.recharts-surface {\n      margin-top: 25px;\n    }\n  }\n\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.shadow;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.glassEffect.blur;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.glassEffect.blur;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.glassBackground;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.breakpoints.sm.maxWidth;
});
var OutputCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  box-shadow: ", ";\n  max-height: 8rem;\n  min-width: 20rem;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 1.5rem 1rem;\n  background: ", ";\n\n  @media screen and (max-width: ", ") {\n    margin: ", ";\n  }\n  box-sizing: border-box;\n"])), function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.shadow;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.glassEffect.blur;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.glassEffect.blur;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.glassBackground;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.breakpoints.lg.minWidth;
}, function (_ref25) {
  var $margin = _ref25.$margin;
  return $margin ? $margin : 'initial';
});
var LatestBlogCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a */ .ZP.a(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  justify-content: flex-end;\n  position: relative;\n  min-height: 100%;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 0;\n  background: ", ";\n  overflow: hidden;\n\n  text-decoration: none;\n\n  @media screen and (max-width: ", ") {\n    margin: ", ";\n  }\n  box-sizing: border-box;\n"])), function (_ref26) {
  var theme = _ref26.theme;
  return theme.glassEffect.blur;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.glassEffect.blur;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.glassBackground;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.breakpoints.lg.minWidth;
}, function (_ref31) {
  var $margin = _ref31.$margin;
  return $margin ? $margin : 'initial';
});
var WarningCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  background: ", ";\n  padding: 1rem;\n  color: black;\n  border-radius: 5px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  justify-content: space-between;\n\n  > p {\n    margin: 0;\n    font-weight: bold;\n  }\n"])), function (_ref32) {
  var theme = _ref32.theme;
  return theme.colors.secondaryGradient;
});
var ImageBGCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(function (_ref33) {
  var _ref34;

  var _ref33$theme = _ref33.theme,
      colors = _ref33$theme.colors,
      glassEffect = _ref33$theme.glassEffect,
      breakpoints = _ref33$theme.breakpoints,
      $img = _ref33.$img;
  return _ref34 = {
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    width: '100%',
    height: '100%',
    borderRadius: glassEffect.borderRadius,
    transition: 'box-shadow 0.56s ease-in-out',
    backgroundColor: colors.cardBackground,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundImage: "url(".concat($img, ")")
  }, (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref34, '&:hover', {
    cursor: 'pointer',
    boxShadow: '0 24px 38px 3px rgba(0,0,0,0.14), 0 9px 46px 8px rgba(0,0,0,0.12), 0 11px 15px -7px rgba(0,0,0,0.2)'
  }), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref34, "@media screen and (max-width: ".concat(breakpoints.sm.maxWidth, ")"), {
    minHeight: '20rem'
  }), _ref34;
});
var BlogCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject7 || (_templateObject7 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  box-shadow: ", ";\n  width: 100%;\n  max-width: 33rem;\n  min-width: 33rem;\n  max-height: 45rem;\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  border-radius: 5px;\n  padding: 2rem;\n  gap: 2rem;\n  cursor: pointer;\n  @media screen and (max-width: ", ") {\n    max-width: 100%;\n  }\n"])), function (_ref35) {
  var theme = _ref35.theme;
  return theme.colors.shadow;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.colors.glassBackground;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.breakpoints.sm.maxWidth;
});

/***/ }),

/***/ 48676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mr": function() { return /* binding */ BTCTextDivider; },
/* harmony export */   "tX": function() { return /* binding */ BlogCardDivider; }
/* harmony export */ });
/* unused harmony export HeroDivider */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71383);
/* harmony import */ var atomic_layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19010);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42997);


var _templateObject, _templateObject2, _templateObject3;



var HeroDivider = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  padding: initial;\n"])));
var BTCTextDivider = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  flex-direction: column;\n  flex: 2;\n  margin-left: 1.5rem;\n  min-height: 35px;\n"])));
var BlogCardDivider = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].hr */ .ZP.hr(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  // border-top: ", ";\n  // width: 100%;\n  margin: 0;\n  padding: 0;\n\n  border: 0;\n  height: 2px;\n  background-image: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return "thin solid ".concat(theme.colors.primaryLowOpacity);
}, function (_ref2) {
  var theme = _ref2.theme;
  return "linear-gradient(to right, transparent, ".concat(theme.colors.primaryLowOpacity, ", transparent)");
});

/***/ }),

/***/ 2798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ blog_list; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./components/atoms/Text.js
var Text = __webpack_require__(68219);
// EXTERNAL MODULE: ./components/atoms/Cards.js
var Cards = __webpack_require__(3749);
// EXTERNAL MODULE: ./components/atoms/Dividers.js
var Dividers = __webpack_require__(48676);
// EXTERNAL MODULE: ./components/atoms/Buttons.js
var Buttons = __webpack_require__(87314);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 29 modules
var format = __webpack_require__(18813);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(42997);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/content/blog-list/BlogList.js












var BlogCard = function BlogCard(_ref) {
  var _blog$thumbnailImage, _blog$thumbnailImage$;

  var blog = _ref.blog;
  var image = blog === null || blog === void 0 ? void 0 : (_blog$thumbnailImage = blog.thumbnailImage) === null || _blog$thumbnailImage === void 0 ? void 0 : (_blog$thumbnailImage$ = _blog$thumbnailImage.data) === null || _blog$thumbnailImage$ === void 0 ? void 0 : _blog$thumbnailImage$.attributes;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: "/blog/".concat(blog.slug),
    legacyBehavior: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Cards.BlogCard, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: image === null || image === void 0 ? void 0 : image.url,
        alt: image === null || image === void 0 ? void 0 : image.alternativeText,
        width: 1920,
        height: 1080,
        objectFit: 'cover'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text.H4, {
        $ellipsis: true,
        children: blog.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Paragraph */.nv, {
        $ellipsis: true,
        $padding: "0",
        $lineHeight: 0.8,
        children: blog.excerpt
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Dividers/* BlogCardDivider */.tX, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* Button */.zx, {
          $primary: true,
          $padding: "0.2rem 1.5rem",
          children: "Read Now"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          itemProp: "datePublished",
          children: (0,format/* default */.Z)(blog.createdAt ? Date.parse(blog.createdAt) : new Date(), 'MMMM do, yyyy')
        })]
      })]
    })
  });
};

var BlogListWrapper = styled_components_browser_esm/* default.div */.ZP.div(function (_ref2) {
  var theme = _ref2.theme;
  return (0,defineProperty/* default */.Z)({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    width: '100%',
    maxWidth: '1000px',
    margin: '0 auto',
    gap: '2rem'
  }, "@media screen and (max-width: ".concat(theme.breakpoints.sm.maxWidth, ")"), {
    gridTemplateColumns: '1fr',
    maxWidth: '95%',
    justifyContent: 'center'
  });
});
function BlogList(_ref4) {
  var blogs = _ref4.blogs;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BlogListWrapper, {
    children: blogs.map(function (blog) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(BlogCard, {
        blog: blog.attributes
      }, blog.id);
    })
  });
}
;// CONCATENATED MODULE: ./components/content/blog-list/index.js

/* harmony default export */ var blog_list = (BlogList);

/***/ })

}]);